import React from 'react';
import { Box, Typography } from '@mui/material';

const WhyUsSection = () => (
  <Box
    id="whoweare"
    sx={{
      width: '100%', background: 'linear-gradient(to bottom right, #0F4279, #1B78DE)', padding: '40px', borderRadius: '5px', margin: '100px 0',
    }}
  >
    <Box className="all-elements">

      <Box
        className="first-row"
        sx={{
          display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, justifyContent: 'space-between', alignItems: { xs: 'none', sm: 'center' }, width: '100%',
        }}
      >
        <Box className="first-column" sx={{ width: { xs: '80%', sm: '30%' } }}>
          <Box sx={{ width: '15%' }}>
            <hr style={{ background: 'linear-gradient(to right, #F49867, #AE67FA)', height: '2px', border: 'none' }} />
          </Box>
          <Box>
            <Typography sx={{
              color: '#fff', fontSize: '22px', fontWeight: '500', lineHeight: { xs: '40px', sm: '70px' },
            }}
            >
              Who We Are
            </Typography>
          </Box>
        </Box>
        <Box className="second-column" sx={{ width: { xs: '100%', sm: '70%' } }}>
          <Typography sx={{ color: '#81AFDD', lineHeight: 'auto', padding: '20px 0' }}>We combine aspects from science, tech, engineering, art, and math to teach our coding & problem solving courses. We believe these skills will launch your child into a bright future. STEAM education is a vital part of every child’s education as they navigate the world and venture to fine-tune their interests and talents.</Typography>
        </Box>
      </Box>
      <Box sx={{
        display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', width: '100%', margin: '80px 0',
      }}
      >
        <Box sx={{ width: { xs: '80%', sm: '45%' } }}>
          <Typography sx={{
            background: 'linear-gradient(to right, #F49867, #AE67FA)', textFillColor: 'transparent', backgroundClip: 'text', fontSize: '30px', fontWeight: '600', lineHeight: '40px',
          }}
          >
            The possibilities are beyond your imagination
          </Typography>
        </Box>
      </Box>
      <Box sx={{
        display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, justifyContent: 'space-between', alignItems: { xs: 'none', sm: 'center' }, width: '100%',
      }}
      >
        <Box sx={{ width: { xs: '100%', sm: '33%' } }}>
          <Box sx={{ width: '15%' }}>
            <hr style={{ background: 'linear-gradient(to right, #F49867, #AE67FA)', height: '2px', border: 'none' }} />
          </Box>
          <Box>
            <Typography sx={{
              color: '#fff', fontSize: '22px', fontWeight: '500', lineHeight: '70px',
            }}
            >
              A learning adventure!
            </Typography>
          </Box>
          <Box>
            <Typography sx={{ color: '#81AFDD', lineHeight: 'auto' }}>Your child has a curious mind. We offer a variety of courses that will keep your child engaged while learning new skills.</Typography>
          </Box>
        </Box>
        <Box sx={{ width: { xs: '100%', sm: '33%' } }}>
          <Box sx={{ width: '15%' }}>
            <hr style={{ background: 'linear-gradient(to right, #F49867, #AE67FA)', height: '2px', border: 'none' }} />
          </Box>
          <Box>
            <Typography sx={{
              color: '#fff', fontSize: '22px', fontWeight: '500', lineHeight: '70px',
            }}
            >
              Learn by doing
            </Typography>
          </Box>
          <Box>
            <Typography sx={{ color: '#81AFDD', lineHeight: 'auto' }}>When kids make something, they get excited! Most of our courses are divided into projects which kids can share with family and friends.</Typography>
          </Box>
        </Box>
        <Box sx={{ width: { xs: '100%', sm: '33%' } }}>
          <Box sx={{ width: '15%' }}>
            <hr style={{ background: 'linear-gradient(to right, #F49867, #AE67FA)', height: '2px', border: 'none' }} />
          </Box>
          <Box>
            <Typography sx={{
              color: '#fff', fontSize: '22px', fontWeight: '500', lineHeight: '70px',
            }}
            >
              Real-time feedback
            </Typography>
          </Box>
          <Box>
            <Typography sx={{ color: '#81AFDD', lineHeight: 'auto' }}>Classes are time for questions and collaboration! During live online sessions, your child will work on projects and get help from their experienced instructor.</Typography>
          </Box>
        </Box>
      </Box>
    </Box>
  </Box>
);

export default WhyUsSection;
